<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      <div class="page-container">
        <div class="card card-light w-100">
          <div class="card-body">
            <div class="container-fluid">
              <app-application-fee-rule-form-content />
              <app-application-fee-rule-tabs-details />
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (this.applicationFeeRuleId) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'ApplicationFeeRule'"
          [entityId]="this.applicationFeeRuleId.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
